export const appUISettingName = 'APP_UI_SETTINGS'
// We can have custom values defined under the 'APP_UI_SETTINGS' property in the settings object
export const enableGroupingSettingName = 'QBEnableGrouping'
